import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { generateGlobalColumns, generateBasicColumn, IDataGridConfig } from '@ts/storybook';
import { IConfigComponent, CDeviceInterface } from '@ts/ui-models';

interface IDeviceInterfaceProps extends IRouterProps {
  infrastructureId?: string;
  deviceTypeInterfaceId?: string;

  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent = (options?: {
  infrastructureId?: string;
  deviceTypeInterfaceId?: string;
}): IConfigComponent => {
  return {
    componentId: 'deviceInterfaces',
    aclId: 'taDeviceInterface',
    entity: 'deviceInterface',
    fetchURL: `/api/deviceInterfaces/${options?.infrastructureId}/${options?.deviceTypeInterfaceId}`,
    mainClass: CDeviceInterface,
  };
};

const DeviceInterface = (props: IDeviceInterfaceProps) => {
  const { infrastructureId, deviceTypeInterfaceId } = props;
  const { configComponent = defaultConfigComponent({ infrastructureId, deviceTypeInterfaceId }), inheritedProps } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false, customId: true },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      //globalCells.name(),
      generateBasicColumn(
        { field: 'deviceTypeInterfaceName', headerName: 'Interface type' },
        { field: 'name', tEntity: 'deviceTypeInterface' }
      ),
      generateBasicColumn({ field: 'customId', headerName: 'ID' }, { field: 'customId' }),
      generateBasicColumn(
        { field: 'infrastructureItemName', headerName: 'Device' },
        { field: 'customId', tEntity: 'infrastructureItem' }
      ),
    ];
  }, [props, configComponent]);
  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={inheritedProps}
    />
  );
};

export default DeviceInterface;
